import { capitalize } from '@/utils/filters.js';

export const globalErrors = ['EMAIL_NOT_VERIFIED'];
export const externalDisabledRoutes = ['settings.connections'];

export const passwordRules = [
    {text: 'At least 8 characters', regex: /.{8,}/},
    {text: 'At least one number [0-9]', regex: /[0-9]+/},
    {text: 'At least one lowercase letter [a-z]', regex: /[a-z]+/},
    {text: 'At least one uppercase letter [A-Z]', regex: /[A-Z]+/},
    {text: 'At least one special symbol [#?!@$%^&*-]', regex: /[#?!@$%^&*-]+/}
];

export const mfaServiceErrors = ['MFA_UNAVAILABLE', 'NO_DEVICES_LINKED', 'TELTONIKA_ID_NOT_AVAILABLE'];

export const whitelist = [
    'continue_url',
    'continue_review_id',
    'response_type',
    'client_id',
    'redirect_uri',
    'code_challenge',
    'code_challenge_method', 
    'state',
    'scope',
    'code',
    'platform'
];

const endpointKeys = {
    'generate': 'password',
    'access':'remote access'
}

export function getResponseMessage(res){
    if(!res) return;
    
    const isSuccess = res.data.success;
    const verb = responseVerb(res.config.method);
    const item = responseItem(res.config.url) || 'item';

    if(isSuccess) return `${capitalize(item)} ${verb}d successfully`;
    return `Failed to ${verb} ${item}`
   
}

function responseVerb(method){
    switch (method) {
        case 'put': 
            return 'update';
        case 'delete':
            return 'remove';
        case 'post':
            return 'create';
    }
}

function responseItem(endpoint){
    const stringArray = endpoint.split("?")[0].match(/([a-zA-Z]+)/g);
    let item = stringArray[stringArray.length-1];
    if (endpointKeys[item]) return endpointKeys[item];
    if (item.slice(-3) === 'ies') return item.slice(0, -3)+'y'; 
    if (item.slice(-1) === 's') return item.slice(0, -1); 
    return item;
}

// export const capitalize = (s) => {
//     if (typeof s !== 'string') return '';
//     return s.charAt(0).toUpperCase() + s.slice(1);
// }

export function copyToClipboard(string) {
    if(!string) return;

    let field = document.createElement("textarea");
    document.body.appendChild(field);
    field.value = string;
    field.select();
    document.execCommand('copy');
    document.body.removeChild(field);
}

export function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : undefined;
}

function getDomain(){
    const hostParts = location.hostname?.split('.');
    return hostParts?.slice(-2).join('.');
}

export function setCookie(name, value){
    const domain = getDomain();

    document.cookie = `${name}=${value};domain=.${domain};secure;samesite=strict;path=/`;
}

export function removeCookie(name){
    const domain = getDomain();

    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=." + domain + ";path=/";
}

export function deleteCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function detectIOSUser(){
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function escapeRegExp(string) {
    if(string) {
        return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
    return;
}

export function camelize(str, remove) {
    let string = str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase()).replace(/[^a-zA-Z0-9]/g, "");
    if(remove) string.replace(/[&\\/\\#,+()$~%.'":*?<>{}]/g, '');
    return string;
}

export function validateURL(string) {
    return !!string.match(new RegExp('://'));
}